import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useGetFeedback, useSubmitFeedback } from '../api/feedback-api';
import { reportErrorToConsole } from '../services/error-logger';
import Loader from './Loader';
const CustomerFeedbackSubmit = ({ creditApp, reviewLink, financingProgram, }) => {
    const { t } = useTranslation('shared');
    const navigate = useNavigate();
    const [feedback, isLoadingFeedback] = useGetFeedback(creditApp.id, financingProgram);
    const [submitFeedback] = useSubmitFeedback(financingProgram);
    const postFeedback = useCallback(() => {
        const dto = {
            withdrawalReasonId: null,
            badReviewReasonId: null,
            contactClient: false,
            isSatisfied: true,
            creditApplicationId: creditApp.id,
        };
        submitFeedback(dto).catch(reportErrorToConsole);
    }, [creditApp.id, submitFeedback]);
    const navigateToBadReview = useCallback(() => {
        navigate(`/creditApplication/${creditApp.id}/badReview`, { replace: false });
    }, [creditApp.id, navigate]);
    if (isLoadingFeedback) {
        return _jsx(Loader, { title: t('common.withYouShortly'), description: t('common.pleaseWait') });
    }
    if (feedback)
        return null;
    return (_jsxs("main", { className: "general-message", children: [_jsx("h4", { className: "subtitle", children: t('overview.rateExperienceStep') }), _jsx("h3", { className: "text-center-mobile", children: t('feedback.rateYourExperience') }), _jsx("div", { style: { width: '100%' }, children: _jsxs("div", { className: "button-group-2 feedback-btn-group", children: [_jsx("div", { tabIndex: 0, role: "button", className: "feedback-btn", onClick: postFeedback, onKeyDown: (e) => {
                                if (e.key === 'Enter')
                                    postFeedback();
                            }, children: _jsxs("a", { href: reviewLink, target: "_blank", rel: "noreferrer", style: { textDecoration: 'none' }, children: [_jsx("i", { className: "fa-light fa-thumbs-up" }), _jsx("button", { type: "button", className: "btn btn-blue", children: t('feedback.goodNews') })] }) }), _jsxs("div", { tabIndex: 0, role: "button", className: "feedback-btn", onClick: navigateToBadReview, onKeyDown: (e) => {
                                if (e.key === 'Enter')
                                    navigateToBadReview();
                            }, children: [_jsx("i", { className: "fa-light fa-thumbs-down fa-flip-horizontal" }), _jsx("button", { type: "button", className: "btn btn-blue", children: t('feedback.badNews') })] })] }) })] }));
};
export default CustomerFeedbackSubmit;
